import { create } from 'zustand';

export type ProfileModal = 'edit' | 'phone' | 'password';

type ProfileModalState = {
  /** The one account modal on screen; `null` = none. One slot, so two can never be open (grilling Q11). */
  open: ProfileModal | null;
  setOpen: (next: ProfileModal | null) => void;
};

export const useProfileModalStore = create<ProfileModalState>((set) => ({
  open: null,
  setOpen: (open) => set({ open }),
}));
